export default __webpack_public_path__ + "static/media/002-hook.7f7ca499.png";